export default {
  scan_with_camera:
    "Scanne mit deiner Handykamera, um die FoodAmigos App herunterzuladen.",
};
